import React from 'react'
import { CancelButton, InputText, InputTextWrapper } from '../styled'

interface SearchBarProps {
  searchTerm: string
  setSearchTerm: (value: string) => void
  setCurrentPage: (value: number) => void
}

const SearchBar: React.FC<SearchBarProps> = ({ searchTerm, setSearchTerm, setCurrentPage }) => {
  return (
    <InputTextWrapper>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 24 24"
        fill="none"
        stroke="grey"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        className="icon icon-tabler icons-tabler-outline icon-tabler-search"
      >
        <path stroke="none" d="M0 0h24v24H0z" fill="none" />
        <path d="M10 10m-7 0a7 7 0 1 0 14 0a7 7 0 1 0 -14 0" />
        <path d="M21 21l-6 -6" />
      </svg>
      <InputText
        type="text"
        placeholder="Search by token name..."
        value={searchTerm}
        onChange={(e) => {
          setSearchTerm(e.target.value)
          setCurrentPage(0)
        }}
      />

      {searchTerm.length > 0 && (
        <CancelButton
          onClick={() => {
            setSearchTerm('')
          }}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            viewBox="0 0 24 24"
            fill="none"
            stroke="white"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            className="icon icon-tabler icons-tabler-outline icon-tabler-x"
          >
            <path stroke="none" d="M0 0h24v24H0z" fill="none" />
            <path d="M18 6l-12 12" />
            <path d="M6 6l12 12" />
          </svg>
        </CancelButton>
      )}
    </InputTextWrapper>
  )
}
export default SearchBar
